export enum SharedAPIActions {
  PortalGetStatusPageAlerts = 'PortalGetStatusPageAlerts',
  // [EXPORT NEW ACTIONS ABOVE] < Needed for generating API Hooks seamlessly
}

export * from './queries';
